import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { EntityContext } from '../../entity';
import Loading from '../../components/loading';

export default function DefaultLayout() {

  const { loading } = useContext(EntityContext)

  return (
    <>
      {loading && <Loading />}
      <Outlet />
    </>
  );
}
